module.exports = "<div class=\"GuideActivities\">\n  <div class=\"GuideActivities-activity\" ng-repeat=\"activity in ::ctrl.activities\">\n    <i class=\"Icon\" ng-class=\"::ctrl.activityIcons[activity]\"></i>\n    <a ui-sref=\"guides.cityFilter({country: ctrl.country, city: ctrl.city, filter: ctrl.rSeoActivities[activity]})\"\n       target=\"_blank\"\n       class=\"Link\"><span ng-bind-html=\"::'ACTIVITIES.' + (activity | uppercase) | translate\"></span></a>\n  </div>\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/directives/guide_activities.html
// module id = 471
// module chunks = 24